import user from 'btm-user-manager'; //eslint-disable-line import/no-extraneous-dependencies
import { getLocalSWID } from './utils';

/**
 *
 * Get Subscription Type.
 *
 * @desc Details about the user's status, based on the BAM  isActive parameter
 *       from their JSON response. isActive=true set value to 'active', isActive=false
 *       set value to 'inactive', if isActive does not exist set value to 'not subscribed'
 *
 * @returns {string}
 * @private
 *
 */
function _getSubscriptionType(subscriptions) {

    let subscriptionType = 'not subscribed';

    if (subscriptions.length > 0) {
        const areAnySubsActive = subscriptions.some((item) => {
            return item.isActive;
        });

        if (areAnySubsActive) {
            subscriptionType = 'active';
        } else {
            subscriptionType = 'inactive';
        }
    }

    return subscriptionType;
}

/**
 *
 * Get Purchase Method.
 *
 * @param subscriptions
 * @returns {string}
 * @private
 *
 */
function _getPurchaseMethod(subscriptions) {
    const programList = [];

    subscriptions.forEach((item) => {
        if (item.source) {
            programList.push(item.source.provider);
        }
    });

    return programList.length > 0 ? (programList.join()).toLowerCase() : 'bamtech';
}

let cachedSubscriptionsPromise = null;

function _getSubscriptions() {
    if (cachedSubscriptionsPromise) {
        return cachedSubscriptionsPromise;
    }
    cachedSubscriptionsPromise = user.subscription.getSubscriptions();
    return cachedSubscriptionsPromise;
}

/**
 *
 * @returns {Promise.<T>}
 */

export const getSubscriptionInfo = function () {

    return _getSubscriptions().then((subscriptions) => {

        return {
            subscriptionType: _getSubscriptionType(subscriptions),
            purchaseMethod: _getPurchaseMethod(subscriptions)
        };

    }).catch((err) => {
        console.error('Error getting purchaseMethod', err);

        return {};
    });
};

function getLocalStorageSubscriptions(fallback = 'not applicable') {
    return user.subscription.getSubscriptionsFromLocalStorage().then((localStorageVal) => {
        if (localStorageVal) {
            return localStorageVal.data.activeSubscriptions.join(',');
        }
        return fallback;
    });
}


export const getEntitlements = function (fallback = 'not applicable') {
    try {
        return getLocalStorageSubscriptions(fallback).then((result) => {
            if (result && (result !== fallback)) {
                return result;
            }
            return _getSubscriptions().then((subs) => {
                return user.subscription.setSubscriptionsInLocalStorage(subs, getLocalSWID());
            }).then(() => {
                return getLocalStorageSubscriptions();
            });
        }).catch((err) => {
            console.log('Error getting localStorage entitlements: ', err);
            return fallback;
        });
    } catch (err) {
        console.error(err);
    }

    return fallback;
};

